import axiosClient from '../axiosClient';
import {
  CreateFolderRequest,
  UpdateFolderRequest,
  MoveFolderRequest,
  ReorderFoldersRequest,
  GetFoldersResponse,
  GetFolderResponse,
  CreateFolderResponse,
  UpdateFolderResponse,
  DeleteFolderResponse,
  MoveFolderResponse,
  ReorderFoldersResponse,
} from '../types/FolderTypes';

export const foldersApi = {
  /**
   * Get all folders in a workspace (flat list + tree structure)
   */
  getFolders: async (workspaceId: string): Promise<GetFoldersResponse> => {
    try {
      const response = await axiosClient.get(`/workspaces/${workspaceId}/folders`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch folders:', error);
      throw error;
    }
  },

  /**
   * Get a specific folder by ID
   */
  getFolder: async (folderId: string): Promise<GetFolderResponse> => {
    try {
      const response = await axiosClient.get(`/folders/${folderId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch folder:', error);
      throw error;
    }
  },

  /**
   * Create a new folder in a workspace
   */
  createFolder: async (
    workspaceId: string,
    data: CreateFolderRequest
  ): Promise<CreateFolderResponse> => {
    try {
      const response = await axiosClient.post(`/workspaces/${workspaceId}/folders`, data);
      return response.data;
    } catch (error) {
      console.error('Failed to create folder:', error);
      throw error;
    }
  },

  /**
   * Update a folder
   */
  updateFolder: async (
    folderId: string,
    data: UpdateFolderRequest
  ): Promise<UpdateFolderResponse> => {
    try {
      const response = await axiosClient.patch(`/folders/${folderId}`, data);
      return response.data;
    } catch (error) {
      console.error('Failed to update folder:', error);
      throw error;
    }
  },

  /**
   * Delete a folder (cascade deletes subfolders)
   */
  deleteFolder: async (folderId: string): Promise<DeleteFolderResponse> => {
    try {
      const response = await axiosClient.delete(`/folders/${folderId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to delete folder:', error);
      throw error;
    }
  },

  /**
   * Move a folder to a new parent
   */
  moveFolder: async (
    folderId: string,
    data: MoveFolderRequest
  ): Promise<MoveFolderResponse> => {
    try {
      const response = await axiosClient.post(`/folders/${folderId}/move`, data);
      return response.data;
    } catch (error) {
      console.error('Failed to move folder:', error);
      throw error;
    }
  },

  /**
   * Reorder folders by updating orderIndex
   */
  reorderFolders: async (data: ReorderFoldersRequest): Promise<ReorderFoldersResponse> => {
    try {
      const response = await axiosClient.patch('/folders/reorder', data);
      return response.data;
    } catch (error) {
      console.error('Failed to reorder folders:', error);
      throw error;
    }
  },
};
